export default __webpack_public_path__ + "static/media/gb_prime.8129cc9c.svg";